import ROUTE_NAMES from 'routes/routeNames';
import { ReducersModal } from 'utils/modals';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { UPDATE_AUTH } from 'store/actionTypes';

const SessionExpiry = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isSessionValid } = useSelector((state: ReducersModal) => state.AuthReducer);

    const handleLogout = () => {
        sessionStorage.clear();
        dispatch({ type: "LOGOUT" });
        dispatch({ type: UPDATE_AUTH, payload: { isSessionValid: null } });
        navigate(ROUTE_NAMES.BASE_ROUTE);
    };

    return (
        <Dialog
            onClose={() => { }}
            disableEscapeKeyDown
            open={isSessionValid === false}>
            <DialogTitle sx={{
                fontSize: '26px',
                fontWeight: 'bold'
            }}>{"Session Expired"}</DialogTitle>
            <DialogContent sx={{
                fontSize: '18px',
                fontWeight: '500'
            }}>
                {"Please login again to continue using application"}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleLogout} color='primary'
                    sx={{
                        fontSize: '18px',
                        fontWeight: '500',
                    }}>
                    {"Logout"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiry;